"use client";
import JSONViewer from "@/components/ui/json-viewer";
import {
  ContextPanelProps,
  TransactionUpdatePayload,
} from "./transaction-context-panel.types";
import { InvoiceSearch } from "./components/invoice-search";
import { PurposeSelector } from "./components/purpose-selector";
import { StatusSelector } from "./components/status-selector";
import { TransactionExtended, UserExtended } from "@/types";
import {
  TransactionPurpose,
  WorkflowStatus,
  Transaction,
} from "@prisma/client";
import { useAppStore, selectUser } from "@/store/appStore";
import { AppStoreState } from "@/store/appStore";
import { useContext } from "react";
import { TransactionContext } from "../../context";
import { InvoiceList } from "./components/invoice-list";
import { InvoiceExtended } from "@/types";
import { TransactionNotes } from "./components/transaction-notes";
import "./transaction-context-panel.style.css";

import { ContextPanel } from "@/app/report/components/page";
import { CurrencyCode } from "@/components/ui/flag/flag";
import dayjs from "dayjs";
import { CurrencyValue } from "@/components/ui/currency-value";

const TransactionContextPanel = () => {
  const user = useAppStore(selectUser);
  const transactionContext = useContext(TransactionContext);
  const selectedTransaction =
    transactionContext && transactionContext.selectedTransaction;

  // Conditional Match Tab Sections
  const matchTabSections = [
    {
      title: "Invoice",
      children: (
        <>
          {selectedTransaction && (
            <InvoiceSearch
              transaction={selectedTransaction}
              onSelect={() => {}}
            />
          )}
          {selectedTransaction &&
          selectedTransaction.invoices &&
          selectedTransaction.invoices.length ? (
            <InvoiceList
              invoices={selectedTransaction.invoices as InvoiceExtended[]}
            />
          ) : undefined}
        </>
      ),
    },
    {
      title: "Purpose",
      children: <PurposeSelector onChange={() => {}} />,
    },
    {
      title: "Status",
      children: <StatusSelector onChange={() => {}} />,
    },
  ];

  if (selectedTransaction) {
    matchTabSections.push({
      title: "Notes",
      children: (
        <TransactionNotes
          onChange={() => {}}
          note={selectedTransaction.note || ""}
        />
      ),
    });
  }

  const remittanceInfo =
    selectedTransaction && selectedTransaction.remittanceInformation
      ? selectedTransaction.remittanceInformation.trim()
      : "";
  const additionalInfo =
    selectedTransaction &&
    selectedTransaction.remittanceInformation &&
    selectedTransaction.additionalInformation
      ? `(${selectedTransaction.additionalInformation.toLowerCase().trim()})`
      : !remittanceInfo &&
        selectedTransaction &&
        selectedTransaction.additionalInformation &&
        selectedTransaction.additionalInformation.toLowerCase().trim();

  return (
    <ContextPanel
      header={{
        image: selectedTransaction?.invoices[0]?.seller.corporateWebsiteURL
          ? {
              type: "logo",
              label:
                selectedTransaction && selectedTransaction.bankInstitution
                  ? selectedTransaction.bankInstitution.name
                  : "",
              source:
                selectedTransaction?.invoices[0]?.seller.corporateWebsiteURL ??
                selectedTransaction?.bankInstitution.logo,
              fallback:
                selectedTransaction?.invoices[0]?.seller?.shortCompanyName?.charAt(
                  0
                ) || "N/A",
            }
          : {
              type: "avatar",
              label:
                selectedTransaction && selectedTransaction.bankInstitution
                  ? selectedTransaction.bankInstitution.name
                  : "",
              source: selectedTransaction?.bankInstitution.logo,
              fallback:
                selectedTransaction?.bankInstitution.name.charAt(0) || "N/A",
            },
        title: remittanceInfo + " " + (additionalInfo ? additionalInfo : ""),
        subtitle: (
          <>
            <CurrencyValue
              size={"S"}
              amount={
                selectedTransaction && selectedTransaction.amount !== undefined
                  ? selectedTransaction.amount
                  : undefined
              }
              currency={
                selectedTransaction && selectedTransaction.currency
                  ? (selectedTransaction.currency as CurrencyCode)
                  : undefined
              }
            />
            <div className="text-xs text-gray-500">
              {selectedTransaction &&
                dayjs(selectedTransaction.bookingDate).format("MMM Do ")}
              {selectedTransaction &&
                selectedTransaction.bookingDateTime &&
                dayjs(selectedTransaction.bookingDateTime).format("h:mma")}
            </div>
          </>
        ),
      }}
      tabs={[
        {
          label: "Match",
          value: "preview",
          sections: matchTabSections,
        },
        {
          label: "Data",
          value: "data",
          sections: [
            {
              title: "Data",
              children: (
                <>
                  {selectedTransaction && (
                    <JSONViewer data={selectedTransaction} />
                  )}
                  {!selectedTransaction && <div>No transaction selected</div>}
                </>
              ),
            },
          ],
        },
      ]}
    />
  );
};
export { TransactionContextPanel };
